import React, { useEffect, useState } from 'react';
import { useParams } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { saveAs } from 'file-saver';
import { DropdownMenu } from '@uhg-abyss/web/ui/DropdownMenu';
import { useSelector } from 'react-redux';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { styled } from '@uhg-abyss/web/tools/styled';

import { LagoonContext } from '@src/AppContext';
import { APIOverviewContent } from './APIOverviewContent';
import { Breadcrumbs } from '@uhg-abyss/web/ui/Breadcrumbs';
import { mapBreadcrumbsData } from '@src/common/Utils/utils';
import { animateScroll } from 'react-scroll';

const DivSpacer = styled('div', {
  paddingTop: '20px',
});

export const APIOverview = () => {
  const lagoonContext = React.useContext(LagoonContext);
  const [breadcrumbItems, setBreadcrumbItems] = useState([]);

  const apiOverview = lagoonContext?.getTable('api-overview').getRow();
  const dataDictionaries = lagoonContext
    ?.getTable('data-dictionaries')
    .getRow();
  const userInfo = useSelector((state) => {
    return state.GET_USER_INFO.data;
  });
  const isUserSignedIn = userInfo && userInfo.uuid;

  const { apiName } = useParams();

  const getResource = () => {
    if (apiName) {
      return apiName;
    }
    return 'superconnector-overview';
  };

  const datadownload = (excelFile, fileName) => {
    saveAs(excelFile, fileName);
  };

  const getDataDictionaryList = () => {
    const dataDictionariesLagoonList = dataDictionaries;

    const resourceDataDictionaryList = dataDictionariesLagoonList?.filter(
      (el) => {
        return (
          getResource()
            .replace(/-/g, '')
            .replace('overview', '')
            .toLowerCase() === el.api.toLowerCase() && el.active
        );
      }
    );

    const dataDictionaryList = [];
    if (resourceDataDictionaryList) {
      resourceDataDictionaryList.forEach((element) => {
        const dataObject = {
          title: element.title,
          onClick: () => {
            return datadownload(element.fileUrl, element.fileName);
          },
          icon: <IconSymbol icon="download" size="16px" />,
          isSeparated: element.isSeparated,
        };
        dataDictionaryList.push(dataObject);
      });
    }

    return dataDictionaryList;
  };

  const filteredPageContent = apiOverview?.filter((el) => {
    return el.id === getResource();
  });

  const pageContent = filteredPageContent?.length ? filteredPageContent[0] : '';

  const breadcrumbsData = useSelector((state) => {
    return state.BREADCRUMBS.data;
  });

  useEffect(() => {
    animateScroll.scrollToTop();
  }, [window.location.hash]);

  useEffect(() => {
    // Use the breadcrumbs data from Redux
    if (breadcrumbsData && Array.isArray(breadcrumbsData)) {
      const items = mapBreadcrumbsData(breadcrumbsData);
      setBreadcrumbItems(items);
    }
  }, [breadcrumbsData]); // Only re-run when breadcrumbs data or URL changes

  return (
    <React.Fragment>
      <DivSpacer />
      <Breadcrumbs
        size="11px"
        css={{
          fontWeight: 400,
          'abyss-breadcrumb-current': { fontWeight: 400 },
        }}
        items={breadcrumbItems}
      />
      <DivSpacer />
      {window.location.href.includes('overview') && (
        <Flex justify="space-between">
          <Heading>Overview</Heading>
          {pageContent?.displayDownloadDropdown && isUserSignedIn && (
            <DropdownMenu
              label={pageContent?.downloadDropdownLabel}
              outline
              before={<IconSymbol icon="download" size="20px" />}
              after={<IconSymbol icon="keyboard_arrow_down" />}
              menuItems={getDataDictionaryList()}
            />
          )}
        </Flex>
      )}
      <APIOverviewContent content={pageContent?.overviewContent} />
    </React.Fragment>
  );
};
